// Selector to get the entire events state
export const selectEventsState = (state) => state.event;

// Selector to get the loading status for events actions (list, filter, search)
export const selectEventsLoading = (state) => state.event?.loading ?? false;

// Selector to get the error for events actions (list, filter, search)
export const selectEventsError = (state) => state.event?.error;

// Selector to get the list of events (includes filtered or search results)
export const selectEventsData = (state) => state.event?.events?.data ?? [];

// Selector to get the current page for pagination
export const selectEventsCurrentPage = (state) => state.event?.events?.currentPage ?? 1;

// Selector to get the total number of records
export const selectEventstotalRecords = (state) => state.event?.events?.totalRecords ?? 0;

// Selector to get the number of items per page
export const selectEventsPageSize = (state) => state.event?.events?.pageSize ?? 10;

// Selector to get the next page URL
export const selectEventsNextPageUrl = (state) => state.event?.events?.nextPageUrl;

// Selector to get the previous page URL
export const selectEventsPrevPageUrl = (state) => state.event?.events?.prevPageUrl;

// Export selectors
export const selectExportLoading = (state) => state.event?.export?.loading ?? false;
export const selectExportSuccess = (state) => state.event?.export?.success ?? false;
export const selectExportError = (state) => state.event?.export?.error;

// View details selectors
export const selectEventDetails = (state) => state.event?.viewDetails?.data;
export const selectEventDetailsError = (state) => state.event?.viewDetails?.error;

// Update info selectors
export const selectUpdateEventLoading = (state) => state.event?.updateInfo?.loading ?? false;
export const selectUpdateEventSuccess = (state) => state.event?.updateInfo?.success ?? false;
export const selectUpdateEventError = (state) => state.event?.updateInfo?.error;

// Add event selectors
export const selectAddEventLoading = (state) => state.event?.addEvent?.loading ?? false;
export const selectAddEventSuccess = (state) => state.event?.addEvent?.success ?? false;
export const selectAddEventError = (state) => state.event?.addEvent?.error;

// Combined loading selector for any event action
export const selectEventLoading = (state) => 
  selectAddEventLoading(state) || 
  selectUpdateEventLoading(state) || 
  selectExportLoading(state) ||
  selectEventsLoading(state);

// Combined success selector for add/update actions
export const selectEventActionSuccess = (state) =>
  selectAddEventSuccess(state) || 
  selectUpdateEventSuccess(state) ||
  selectExportSuccess(state);

// Combined error selector for any event action
export const selectEventErrors = (state) => ({
  general: selectEventsError(state),
  export: selectExportError(state),
  update: selectUpdateEventError(state),
  add: selectAddEventError(state),
  viewDetails: selectEventDetailsError(state),
});